export default "__VITE_ASSET__Dp5g0wac__"